let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hNNyi")).then(() => parcelRequire('hY7nq'));